/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationData } from './PaginationData';
import {
    PaginationDataFromJSON,
    PaginationDataFromJSONTyped,
    PaginationDataToJSON,
    PaginationDataToJSONTyped,
} from './PaginationData';
import type { Consumer } from './Consumer';
import {
    ConsumerFromJSON,
    ConsumerFromJSONTyped,
    ConsumerToJSON,
    ConsumerToJSONTyped,
} from './Consumer';

/**
 * Paginated list of consumers.
 * @export
 * @interface PaginatedConsumers
 */
export interface PaginatedConsumers {
    /**
     * List of consumers.
     * @type {Array<Consumer>}
     * @memberof PaginatedConsumers
     */
    results: Array<Consumer>;
    /**
     * 
     * @type {PaginationData}
     * @memberof PaginatedConsumers
     */
    pagination: PaginationData;
}

/**
 * Check if a given object implements the PaginatedConsumers interface.
 */
export function instanceOfPaginatedConsumers(value: object): value is PaginatedConsumers {
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function PaginatedConsumersFromJSON(json: any): PaginatedConsumers {
    return PaginatedConsumersFromJSONTyped(json, false);
}

export function PaginatedConsumersFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedConsumers {
    if (json == null) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(ConsumerFromJSON)),
        'pagination': PaginationDataFromJSON(json['pagination']),
    };
}

export function PaginatedConsumersToJSON(json: any): PaginatedConsumers {
    return PaginatedConsumersToJSONTyped(json, false);
}

export function PaginatedConsumersToJSONTyped(value?: PaginatedConsumers | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'results': ((value['results'] as Array<any>).map(ConsumerToJSON)),
        'pagination': PaginationDataToJSON(value['pagination']),
    };
}

